import {mapGetters, mapMutations} from 'vuex';
import toString from 'lodash/toString'

export default {
    props: ['url', 'date'],
    data() {
        return {
            loading: false,
            query: {
                perPage: 10,
                sort: 'name',
                append: 'meets_bundle_requirements',
                filter: {
                    active: 1,
                    keyword: null,
                    bundle_only: null,
                    favorite: null,
                    category: null,
                    dates: null,
                },
            },
            columns: [
                {key: 'name', label: 'Asset Name', sortable: true},
                {key: 'category.name', label: 'Category', sortable: true},
                {
                    key: 'online_price',
                    label: 'Online Base Price',
                    sortable: true,
                },
                {
                    key: 'meets_bundle_requirements',
                    label: 'Ready',
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        ...mapGetters('bundle', ['bundleAssets', 'bundleSelection']),
        selection: {
            get() {
                return this.bundleSelection;
            },
            set(val) {
                this.setCartItems(val);
            },
        },
    },
    methods: {
        ...mapMutations('bundle', ['addAsset', 'setCartItems', 'removeAsset']),
        changedSelection(checked, asset) {
            if (checked) {
                // Only add if not already in bundle_assets
                const alreadyExists = this.bundleAssets.some(a => a.id === asset.id);
                if (!alreadyExists) {
                    this.addAsset(asset);
                }
            } else {
                this.removeAsset(asset.id);
            }
        },
        filterAll() {
            this.query.filter.bundle_only = null;
            this.query.filter.favorite = null;
            this.query.filter.active = null;
            this.$refs.inventoryTable.refresh();
        },
        filterFavorite() {
            this.query.filter.bundle_only = null;
            this.query.filter.favorite = 1;
            this.query.filter.active = null;
            this.$refs.inventoryTable.refresh();
        },
        filterBundleOnly() {
            this.query.filter.favorite = null;
            this.query.filter.bundle_only = 1;
            this.$refs.inventoryTable.refresh();
        },
        filterNotHidden() {
            this.query.filter.bundle_only = null;
            this.query.filter.favorite = null;
            this.query.filter.active = 1;
            this.$refs.inventoryTable.refresh();
        },
        filterCategory(payload) {
            this.query.filter.category = payload;
            this.refresh();
        },
        refresh() {
            this.$refs.inventoryTable.refresh();
        },
    },
    created() {
        Bus.$on('assetFavoriteToggle', this.refresh);
        Bus.$on('categoryFilterSelect', this.filterCategory);
    },
    beforeDestroy() {
        Bus.$off('assetFavoriteToggle', this.refresh);
        Bus.$off('categoryFilterSelect', this.filterCategory);
    },
    watch: {
        date(newValue) {
            if (_.get(newValue, 'start') && _.get(newValue, 'end')) {
                this.query.filter.dates = _.get(newValue, 'start') + ',' + _.get(newValue, 'end');
            } else {
                this.query.filter.dates = null;
            }

            this.$refs.inventoryTable.refresh();
        },
    },
};
